import { useNavigate } from "react-router-dom";

import { signOut } from "@/lib/auth";
import { useAuthUser } from "@/lib/use-auth-user";

import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { Loader } from "@/components/ui/States";
import { DashboardTopbar } from "@/components/layout/DashboardTopbar";
import { RoleSwitcher } from "@/components/RoleSwitcher";
import { InstallAppBlock } from "@/components/account/InstallAppBlock";
import { MyAccountEmailBlock } from "@/components/account/MyAccountEmailBlock";
import { MyAccountTelegramBlock } from "@/components/account/MyAccountTelegramBlock";

export function AccountSettingsPage() {
  const navigate = useNavigate();
  const { user, loading } = useAuthUser();

  const onSignOut = async () => {
    await signOut();
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#F0F2F5]">
      <DashboardTopbar />

      <main className="mx-auto w-full max-w-[680px] px-5 py-8 pb-24 md:px-10 md:py-10 md:pb-10">
        <button
          type="button"
          onClick={() => navigate("/me/meetups")}
          className="mb-3 inline-flex items-center gap-1 text-[13px] font-semibold text-[#475569] hover:text-[#2563eb]"
        >
          ← My events
        </button>
        <h1 className="text-[24px] font-bold tracking-tight text-[#1a1a1a]">Account</h1>

        {loading ? (
          <Loader label="Loading..." />
        ) : (
          <>
            <Card padding="lg" className="mt-5">
              <div className="flex items-center gap-4">
                <div className="h-16 w-16 shrink-0 overflow-hidden rounded-full border-2 border-[#e2e8f0] bg-gradient-to-br from-[#dbeafe] to-[#bfdbfe]">
                  {user?.avatarUrl ? (
                    <img src={user.avatarUrl} alt="" className="h-full w-full object-cover" />
                  ) : null}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-[11px] font-bold uppercase tracking-wide text-[#94a3b8]">Profile</p>
                  <p className="mt-1 text-[16px] font-semibold text-[#1a1a1a]">{user?.fullName ?? "—"}</p>
                  <p className="mt-0.5 truncate text-[13px] text-[#6c757d]">{user?.email ?? "—"}</p>
                </div>
              </div>
            </Card>

            <MyAccountEmailBlock />

            <MyAccountTelegramBlock />

            <InstallAppBlock />

            <div className="mt-5">
              <RoleSwitcher />
            </div>

            <div className="mt-8 border-t border-[#e2e8f0] pt-6">
              <Button variant="secondary" onClick={onSignOut} fullWidth>
                Sign out
              </Button>
            </div>
          </>
        )}
      </main>
    </div>
  );
}
